export default function() {
  return {
    type: 'INITIAL_PAGE_LOAD',
    initialPageLoad: false
  };
}



// WEBPACK FOOTER //
// ./src/redux/action_creators/initial_load_action_creator.js